/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "surface_scan";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface InspectionType {
}

export enum InspectionType_Enum {
  INVALID = 0,
  SURFACE = 1,
  MESH = 2,
  AREA = 3,
  ORBIT = 4,
  SINGLE_ORBIT = 12,
  EXPLORATION_ORBIT = 15,
  PERIMETER = 5,
  MANUAL = 6,
  COLUMN = 7,
  CONTOUR = 8,
  VERTEX_COLUMN = 9,
  LONG_RANGE_EXPLORE = 10,
  RELOCALIZATION = 11,
  LONG_RANGE_CONTOUR = 13,
  STRUCTURE_COLUMN = 14,
  SINGLE_COLUMN = 16,
  DIAGONAL = 17,
  UNRECOGNIZED = -1,
}

export function inspectionType_EnumFromJSON(object: any): InspectionType_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return InspectionType_Enum.INVALID;
    case 1:
    case "SURFACE":
      return InspectionType_Enum.SURFACE;
    case 2:
    case "MESH":
      return InspectionType_Enum.MESH;
    case 3:
    case "AREA":
      return InspectionType_Enum.AREA;
    case 4:
    case "ORBIT":
      return InspectionType_Enum.ORBIT;
    case 12:
    case "SINGLE_ORBIT":
      return InspectionType_Enum.SINGLE_ORBIT;
    case 15:
    case "EXPLORATION_ORBIT":
      return InspectionType_Enum.EXPLORATION_ORBIT;
    case 5:
    case "PERIMETER":
      return InspectionType_Enum.PERIMETER;
    case 6:
    case "MANUAL":
      return InspectionType_Enum.MANUAL;
    case 7:
    case "COLUMN":
      return InspectionType_Enum.COLUMN;
    case 8:
    case "CONTOUR":
      return InspectionType_Enum.CONTOUR;
    case 9:
    case "VERTEX_COLUMN":
      return InspectionType_Enum.VERTEX_COLUMN;
    case 10:
    case "LONG_RANGE_EXPLORE":
      return InspectionType_Enum.LONG_RANGE_EXPLORE;
    case 11:
    case "RELOCALIZATION":
      return InspectionType_Enum.RELOCALIZATION;
    case 13:
    case "LONG_RANGE_CONTOUR":
      return InspectionType_Enum.LONG_RANGE_CONTOUR;
    case 14:
    case "STRUCTURE_COLUMN":
      return InspectionType_Enum.STRUCTURE_COLUMN;
    case 16:
    case "SINGLE_COLUMN":
      return InspectionType_Enum.SINGLE_COLUMN;
    case 17:
    case "DIAGONAL":
      return InspectionType_Enum.DIAGONAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return InspectionType_Enum.UNRECOGNIZED;
  }
}

export function inspectionType_EnumToJSON(object: InspectionType_Enum): string {
  switch (object) {
    case InspectionType_Enum.INVALID:
      return "INVALID";
    case InspectionType_Enum.SURFACE:
      return "SURFACE";
    case InspectionType_Enum.MESH:
      return "MESH";
    case InspectionType_Enum.AREA:
      return "AREA";
    case InspectionType_Enum.ORBIT:
      return "ORBIT";
    case InspectionType_Enum.SINGLE_ORBIT:
      return "SINGLE_ORBIT";
    case InspectionType_Enum.EXPLORATION_ORBIT:
      return "EXPLORATION_ORBIT";
    case InspectionType_Enum.PERIMETER:
      return "PERIMETER";
    case InspectionType_Enum.MANUAL:
      return "MANUAL";
    case InspectionType_Enum.COLUMN:
      return "COLUMN";
    case InspectionType_Enum.CONTOUR:
      return "CONTOUR";
    case InspectionType_Enum.VERTEX_COLUMN:
      return "VERTEX_COLUMN";
    case InspectionType_Enum.LONG_RANGE_EXPLORE:
      return "LONG_RANGE_EXPLORE";
    case InspectionType_Enum.RELOCALIZATION:
      return "RELOCALIZATION";
    case InspectionType_Enum.LONG_RANGE_CONTOUR:
      return "LONG_RANGE_CONTOUR";
    case InspectionType_Enum.STRUCTURE_COLUMN:
      return "STRUCTURE_COLUMN";
    case InspectionType_Enum.SINGLE_COLUMN:
      return "SINGLE_COLUMN";
    case InspectionType_Enum.DIAGONAL:
      return "DIAGONAL";
    case InspectionType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseInspectionType(): InspectionType {
  return {};
}

export const InspectionType = {
  encode(_: InspectionType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InspectionType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInspectionType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): InspectionType {
    return {};
  },

  toJSON(_: InspectionType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<InspectionType>, I>>(base?: I): InspectionType {
    return InspectionType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InspectionType>, I>>(_: I): InspectionType {
    const message = createBaseInspectionType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
